import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { ConnectSocialBarComponent } from './connect-social-bar.component';

import { SharedPipesModule } from '../../../shared/pipes/shared-pipes.module';

@NgModule({
    imports: [
        CommonModule,
        SharedPipesModule,
        TranslateModule.forChild()
    ],
    declarations: [
        ConnectSocialBarComponent
    ],
    exports: [
        ConnectSocialBarComponent
    ]
})
export class ConnectSocialBarModule { }
